import { render, staticRenderFns } from "./classmanagetable.vue?vue&type=template&id=08bd48b0&scoped=true&"
import script from "./classmanagetable.vue?vue&type=script&lang=js&"
export * from "./classmanagetable.vue?vue&type=script&lang=js&"
import style0 from "./classmanagetable.vue?vue&type=style&index=0&id=08bd48b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bd48b0",
  null
  
)

export default component.exports